import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      retryDelay: 2000,
      staleTime: Infinity,
    },
  },
});

export const VERSION_CHECK_QUERY_KEY = ["version-check"];
